// Mira Vance — The Open Letter (Cream paper · Ink-black · Bordeaux)
export const META = {
  brand: 'Mira Vance',
  tag: 'Executive correspondent · Field notes since 2014',
  paper: 'The Open Letter',
  issue: 'Vol. XII · No. 47 · Friday, February 9, 2026',
  byline: 'M. V. — New York & Berlin',
  est: '2014',
};

export const ROUTES = [
  { id: 'home', label: 'The Letter', no: 'I' },
  { id: 'notes', label: 'Field Notes', no: 'II' },
  { id: 'engagements', label: 'Engagements', no: 'III' },
  { id: 'apply', label: 'Correspondence', no: 'IV' },
];

export const ESSAYS = [
  { iss: '47', date: 'Feb 9, 2026', read: '8 min', cat: 'Leadership', t: 'On the cost of always answering quickly.', d: 'A note on slowness, and the executive who refused to clear her inbox until Friday afternoons.' },
  { iss: '46', date: 'Jan 26, 2026', read: '11 min', cat: 'Identity', t: 'The chief executive as a private person.', d: 'What happens when the CEO becomes a public figure — and the family that quietly stays put.' },
  { iss: '45', date: 'Jan 12, 2026', read: '6 min', cat: 'Field Note', t: 'A morning in Davos, watching the powerful eat eggs.', d: 'Three CEOs at one breakfast table. None of them spoke about the conference.' },
  { iss: '44', date: 'Dec 22, 2025', read: '9 min', cat: 'Coaching', t: 'Why the founder keeps firing herself.', d: 'A pattern I see in twenty-something founders who built something larger than they expected.' },
  { iss: '43', date: 'Dec 8, 2025', read: '7 min', cat: 'Identity', t: 'The first six months after stepping down.', d: 'Notes from three former operators who left at the top, and what they did with the silence.' },
  { iss: '42', date: 'Nov 24, 2025', read: '12 min', cat: 'Leadership', t: 'On having a chief of staff who tells you the truth.', d: 'And on the ceiling that arrives when you don\u2019t.' },
];

export const ENGAGEMENTS = [
  { mode: 'Private coaching', cad: 'Six months · monthly correspondence + two intensives', for: 'CEOs & founders, late-stage', from: '$48,000', avail: '4 seats / year', cur: '2 open · 2026' },
  { mode: 'Workshop · Off-the-record', cad: 'Two days · 12 seats only · in-person', for: 'Leadership teams · Series B+', from: '$42,000', avail: 'Three per year', cur: 'June, Sept, Dec' },
  { mode: 'Lecture · Keynote', cad: '45 min talk + Q&A · single appearance', for: 'Conferences · investor offsites', from: '$28,000', avail: 'Six per year', cur: '2 open · 2026' },
];

export const CALENDAR_2026 = [
  { mo: 'Feb', city: 'New York', t: 'Workshop · 12 seats · sold out', state: 'closed' },
  { mo: 'Mar', city: 'London', t: 'Keynote · Founders\u2019 Forum', state: 'open' },
  { mo: 'Apr', city: 'Berlin', t: 'Coaching cohort · seat 2 of 4', state: 'open' },
  { mo: 'Jun', city: 'Aspen', t: 'Workshop · Off-the-Record', state: 'waitlist' },
  { mo: 'Sep', city: 'Singapore', t: 'Workshop · Off-the-Record', state: 'open' },
  { mo: 'Oct', city: 'Paris', t: 'Keynote · Slow Hand Conference', state: 'open' },
  { mo: 'Dec', city: 'New York', t: 'Workshop · Off-the-Record', state: 'open' },
];

export const PRESS = [
  'The New York Times', 'Financial Times', 'The Atlantic', 'Stratechery', 'Monocle', 'The Browser', 'Lenny\u2019s Newsletter',
];
